import { Box, BoxProps } from '@chakra-ui/react/box';
import { Text } from '@chakra-ui/react/text';

import { DataTableHeader, DataTableRow } from '../types/DataTable.type';

type DataTableRowMobileProps = {
  row: DataTableRow;
  headers: DataTableHeader[];
  rowProps?: BoxProps;
  headerWidth?: BoxProps['w'];
};

const DataTableRowMobile = ({ row, headers, rowProps = {}, headerWidth }: DataTableRowMobileProps) => {
  const { fields } = row;
  const onClick = 'onClick' in row ? row.onClick : undefined;

  return (
    <Box
      display="flex"
      flexDirection="column"
      paddingX={24}
      paddingY={12}
      whiteSpace="normal"
      wordBreak="break-word"
      onClick={onClick}
    >
      {headers.map(({ key: headerKey, label: headerLabel, isActionButton }) => {
        return (
          <Box key={headerKey} display="flex" gap={12} paddingY={10} {...rowProps}>
            {isActionButton ? (
              fields[headerKey]
            ) : (
              <>
                <Text flexShrink={0} textStyle="heading/h5" w={headerWidth || 84}>
                  {headerLabel}
                </Text>
                <Text as="span" minW={0} paddingLeft={12} textStyle="body/md/regular">
                  {fields[headerKey]}
                </Text>
              </>
            )}
          </Box>
        );
      })}
      {'expandableContent' in row &&
        row.expandableContent &&
        (typeof row.expandableContent === 'function' ? row.expandableContent(row) : row.expandableContent)}
    </Box>
  );
};

export default DataTableRowMobile;
